module.exports = __webpack_public_path__ + "img/emoObjects.4a37c18a.svg";